<!-- 特色数据 -->
<template>
  <div v-if="isShow" class="feature-data">
    <div class="top-title row">
      <div class="left-title row">
        <div>特色数据</div>
        <img :src="TIP_ICON" class="tip-icon" @click="() => { this.showModal = true }" />
      </div>
      <div class="right-title row" @click="clickMore">
        <div>更多</div>
        <img :src="RIGHT_ARROW" class="arrow" />
      </div>
    </div>
    <!-- tab切换 -->
    <tab-switch
      :cur-index="curIndex"
      :tab-list="tabList"
      @clickTab="(e) => { this.curIndex=e.index}"/>
    <!-- 数据内容 -->
    <div v-if="!$isEmpty(featureData) && !featureData.isEmpty" class="content">
      <div v-for="(item, index) in featureData.list" :key="index" class="feature-item row">
        <div class="left-value">
          <div class="value">{{item.value}}</div>
          <div>{{item.name}}</div>
        </div>
        <div class="right-bar">
          <div class="top-level row">
            <div>{{item.levelText}}</div>
            <div class="level-desc">
              <div v-if="item.compare !== '暂无排行'"
                :style="{
                  backgroundColor: item.percent < 0.5 ? '#EBF3FE' : '#FEEEE7'
                }"
                class="level-bg"></div>
              <div
                :class="[item.compare !== '暂无排行' ? 'rank-compare' : 'empty-compare-text']"
                >{{item.compare}}</div>
            </div>
          </div>
          <div class="level-arrow" id="arrow-container">
            <img
              v-if="item.compare !== '暂无排行'"
              :src="item.percent < 0.5 ? BLUE_ARROW : RED_ARROW"
              :style="{left: `${getProcessWidth(arrowContainerWidth,item.percent) - 6}px`}"
              class="arrow-icon" />
          </div>
          <div class="color-bar" :style="{
              backgroundColor: item.compare !== '暂无排行'
              ? item.percent < 0.5 ? '#EBF3FE' : '#FEEEE7'
              : '#eeeeee'
            }">
            <div class="color-progress" v-if="item.compare !== '暂无排行'" :style="{
                width: `${getProcessWidth(arrowContainerWidth,item.percent)}px`,
                backgroundColor: item.percent
                ? (item.percent < 0.5 ? '#3A90FA' : '#FA5914')
                : '#eeeeee',
              }"></div>
            <div
              v-for="i in 3" :key="i"
              class="blank"
              :style="{ left: `${((arrowContainerWidth-18)/4 + 6)*i}px`}"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-content">{{emptyText}}</div>
    <!-- 提示弹窗 -->
    <div v-if="showModal" class="modal-mask" @click="() => { this.showModal = false }">
      <div class="modal" @click.stop="() => {} ">
        <div v-for="item in alertList" :key="item.title" class="alert-item">
          <p class="content"><span class="dot"></span><span class="title"
            >{{item.title+'：'}}</span><span
            >{{item.content}}</span>
          </p>
          <p class="sub-content">{{item.subContent}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONFIG from '@/configs/default';
import TabSwitch from './FundHold/HoldTabSwitch.vue';

export default {

  name: 'feature-data',

  components: {
    TabSwitch,
  },

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      TIP_ICON: 'https://j5.dfcfw.com/sc/image/202110/20211009012345.png',
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
      BLUE_ARROW: 'https://j5.dfcfw.com/sc/image/202301/20230103075930.png',
      RED_ARROW: 'https://j5.dfcfw.com/sc/image/202109/20210924063708.png',
      tabList: [{ name: '近1年' }, { name: '近3年' }, { name: '近5年' }],
      curIndex: 0,
      arrowContainerWidth: 0,
      showModal: false, // 展示提示弹窗
      alertList: CONFIG.featureDataAlertList, // 提示列表
    };
  },

  computed: {
    isShow() {
      const establishDate = this.basicInfo?.establishDate;
      const now = new Date().getTime();
      const days = (now - Date.parse(establishDate)) / 1000 / 60 / 60 / 24;
      if (days < 365) {
        return false;
      }
      return !this.basicInfo?.isCurrencyFund && !this.basicInfo?.isReitsFund;
    },
    featureData() {
      const dataSource = this.detailInfo?.featureData || [];
      return dataSource[this.curIndex] || {};
    },
    emptyText() {
      const establishDate = this.basicInfo?.establishDate;
      const totalDays = {
        0: 365,
        1: 365 * 3,
        2: 365 * 5,
      };
      if (!establishDate) return '暂无数据';
      const now = new Date().getTime();
      const days = (now - Date.parse(establishDate)) / 1000 / 60 / 60 / 24;
      if (days < totalDays[this.curIndex]) {
        return '成立时间不足，暂无数据';
      }
      return '暂无数据';
    },
  },

  updated() {
    const containerEl = document.getElementById('arrow-container');
    this.arrowContainerWidth = (containerEl?.offsetWidth) || 0;
  },

  methods: {
    clickMore() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.tssj.click', '');
      this.$goFundApp();
    },
    // 获取进度条长度-主要是为了处理空白断点
    getProcessWidth(containerWidth, percent) {
      const itemBarWidth = parseFloat((containerWidth - 18) / 4);
      if (percent <= 0.25) {
        return containerWidth * percent;
      }
      if (percent > 0.25 && percent <= 0.5) {
        return itemBarWidth + 6 + containerWidth * (percent - 0.25);
      }
      if (percent > 0.5 && percent <= 0.75) {
        return (itemBarWidth + 6) * 2 + containerWidth * (percent - 0.5);
      }
      return Math.min(
        Math.ceil((itemBarWidth + 6) * 3 + containerWidth * (percent - 0.75)), containerWidth,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.feature-data {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .top-title {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 40px;
    .left-title {
      font-size: 32px;
      font-weight: bold;
      color: #000000;
      .tip-icon {
        width: 28px;
        height: 28px;
        margin-left: 8px;
      }
    }
    .right-title {
      font-size: 28px;
      color: #666666;
      .arrow {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
  }
  .content {
    width: 100%;
    margin-top: 40px;
    .feature-item {
      margin-bottom: 56px;
      .left-value {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #666666;
        width: 150px;
        .value {
          font-family: DINAlternate-Bold;
          font-size: 36px;
          color: #000000;
          max-width: 180px;
          margin-bottom: 16px;
        }
      }
      .right-bar {
        margin-left: 30px;
        width: 100%;
        .top-level {
          font-family: PingFangSC-Semibold;
          font-size: 28px;
          color: #000000;
          font-weight: 600;
          .level-desc {
            .level-bg {
              margin-left: 16px;
              height: 16px;
            }
            .rank-compare {
              bottom: 0;
              font-family: PingFangSC-Regular;
              font-size: 24px;
              color: #666666;
              font-weight: 400;
              margin-left: 16px;
              margin-top: -16px;
              line-height: 0;
            }
            .empty-compare-text {
              font-family: PingFangSC-Semibold;
              font-size: 28px;
              color: #000000;
              font-weight: 600;
            }
          }
        }
        .level-arrow {
          width: 100%;
          height: 16px;
          margin-top: 4px;
          position: relative;
          .arrow-icon {
            position: absolute;
            width: 20px;
            height: 16px;
          }
        }
        .color-bar {
          margin-top: 4px;
          width: 100%;
          overflow: hidden;
          height: 12px;
          border-radius: 6px;
          position: relative;
          .color-progress {
            height: 12px;
          }
          .blank {
            position: absolute;
            top: 0;
            height: 12px;
            width: 6px;
            background-color: #ffffff;
          }
        }
      }
    }
    .feature-item:last-child {
      margin-bottom: 0;
    }
  }
  .empty-content {
    height: 250px;
    line-height: 250px;
    color: #999999;
    font-family: PingFangSC-Regular;
    font-size: 30px;
    text-align: center;
  }
  .modal-mask {
    z-index: 10000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .modal {
      max-height: 80%;
      overflow-y: auto;
      width: 75%;
      background-color: #ffffff;
      border-radius: 24px;
      padding: 32px;
      box-sizing: border-box;
      .alert-item {
        margin-bottom: 24px;
      }
      p {
        text-align: left;
        font-size: 30px;
        line-height: 45px;
        color: #666;
        margin: 0;
        .title {
          font-weight: 700;
        }
        .dot {
          display: inline-block;
          margin-right: 12px;
          margin-bottom: 8px;
          background-color: #666666;
          width: 10px;
          height: 10px;
          border-radius: 10px;
        }
      }
      .sub-content {
        font-size: 24px;
        line-height: 30px;
        text-align: left;
        color: #999999;
      }
    }
  }
}
</style>
